<template>
    <div class="col-span-12 w-full flex flex-col relative">
        <EmptyState
            v-if="searchState === 'empty' || searchState === 'error'"
            title="No lounges found"
            description="Try changing your search parameters."
            :hasAction="false"
        >
            <template #image>
                <div
                    class="w-16 h-16 bg-slate-200 rounded-full justify-center items-center flex"
                >
                    <Icon icon="search" svgClass="w-8 h-8" />
                </div>
            </template>
        </EmptyState>
        <div
            v-if="searchState === 'results'"
            v-for="(lounges, terminal, tIndex) in filteredSearchResults"
            :key="'terminal-' + tIndex"
            :class="{ 'mt-8': lounges.length && tIndex > 0 }"
        >
            <div
                v-if="lounges.length > 0"
                class="self-stretch flex-col justify-start items-start flex text-slate-800 text-lg font-medium font-['Inter'] leading-7 pt-3 pb-4"
            >
                {{ terminal }}
            </div>
            <div
                class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-x-6 gap-y-8"
            >
                <LoungeCard
                    v-for="(lounge, lIndex) in lounges"
                    :lounge="lounge"
                    :index="lIndex"
                    :key="'lounge-' + lIndex"
                />
            </div>
        </div>
    </div>
</template>

<script>
import { storeToRefs } from 'pinia';
import { useLoungesStore } from '@/store/lounges';
import Icon from '@/components/ui/icon/icon.vue';
import LoungeCard from '@/components/tools/lounges/partials/lounge-card/lounge-card.vue';
import EmptyState from '@/components/ui/empty-state/empty-state.vue';
import EmptyResultsFiltered from '@/components/hotels/search/empty-results/filtered.vue';
import EmptyResultsSearch from '@/components/hotels/search/empty-results/search.vue';

export default {
    components: {
        LoungeCard,
        EmptyState,
        EmptyResultsFiltered,
        EmptyResultsSearch,
        Icon,
    },
    setup() {
        const loungesStore = useLoungesStore();
        const { filteredSearchResults, searchResults, searchState } =
            storeToRefs(loungesStore);

        return {
            filteredSearchResults,
            searchState,
            searchResults,
        };
    },
};
</script>
